import {
    ChangeDetectionStrategy, Component, input,
    output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ProductSizeSelectorLayoutComponent } from '../product-size-selector';
import { ProductSizeSelectorModeEnum } from '../product-size-selector/domain/constants/product-size-selector.constants';
import { ProductViewConfig } from '../product-view/models/product-view-config.model';

import { ProductPublicModels } from '@features/products/product';

@Component({
    selector: 'product-view-size-selector',
    templateUrl: './product-view-size-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslateModule,
        ProductSizeSelectorLayoutComponent,
    ],
})
export class ProductViewSizeSelectorComponent {
    public product = input.required<ProductPublicModels.PublicProduct>();

    public config = input<ProductViewConfig>();

    public categoryId = input<string>();

    public productSizeMode = ProductSizeSelectorModeEnum;

    public readonly addToCartEvent = output<{
        size: ProductPublicModels.PublicProductSize;
        product: ProductPublicModels.PublicProduct & { idMedia?: string };
    }>();

    public readonly showAvailabilityEvent = output<{
        size: ProductPublicModels.PublicProductSize;
        product: ProductPublicModels.PublicProduct;
    }>();

    public addToCart(size: ProductPublicModels.PublicProductSize, product: ProductPublicModels.PublicProduct): void {
        this.addToCartEvent.emit({ size, product: { ...product, idMedia: this.config().media?.idMedia } });
    }

    public showAvailability(size: ProductPublicModels.PublicProductSize, product: ProductPublicModels.PublicProduct): void {
        this.showAvailabilityEvent.emit({ size, product: product });
    }
}
